import React from 'react'
import { connect } from 'react-redux'
import Draggable from 'react-draggable'
import _ from 'lodash'
import styled from 'styled-components'



const RotateWrapper = styled.div`
    position:absolute;
    width: 100%;
    height: 100%;
    .central-point{
        position: absolute;
        top: 50%;
        left: 50%;
    }
`

const Dragger = styled.div`
    position: absolute;
    left: 50%;
    top: -60px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #f0f;


`

const RotateZone = styled.div`
    position: absolute;
    left: -10000px;
    top: -10000px;
    width: 1000000px;
    height: 1000000px;
`


export class RotateModul extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mouseIsDown: false
        }

        this.centralPoint = null;
    }


    mouseDownHandler() {
        // this.mouseIsDown = true
        this.setState({
            mouseIsDown: true
        })
    }

    mosueMoveHandler(event) {
        if (this.state.mouseIsDown) {
            const dragPosition = { x: event.pageX, y: event.pageY }
            const { x, y } = this.centralPoint.getBoundingClientRect();

        }
    }

    mouseUpHandler() {
        this.setState({
            mouseIsDown: false
        })
    }

    render() {
        return (
            <RotateWrapper>

                <Dragger className='dragg'
                    onMouseDown={() => this.mouseDownHandler()}
                    onMouseMove={(e) => this.mosueMoveHandler(e)}
                    onMouseUp={() => this.mouseUpHandler()}
                />
                
                <RotateZone style={{ display: this.state.mouseIsDown ? 'block' : 'none' }} />
                <div className='central-point' ref={ref => this.centralPoint = ref} />
            </RotateWrapper>
        )
    }
}
